import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileTabBar.css';

const HomeIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5 9.5V21h14V9.5" />
    </svg>
);

const HeartIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.5 4.04 3 5.5l7 7Z" />
    </svg>
);

const PlusIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="26" height="26">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v8M8 12h8" />
    </svg>
);

const MessageIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    </svg>
);

const ProfileIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
);

const MobileTabBar = ({ user, msgUnread, onRequireAuth, onCreateAd, onGoToTab }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    const handleFavorites = () => {
        if (!user) return onRequireAuth();
        onGoToTab('favorites');
    };

    const handleMessages = () => {
        if (!user) return onRequireAuth();
        onGoToTab('messages');
    };

    const handleProfile = () => {
        if (!user) return onRequireAuth();
        navigate('/profile');
    };

    return (
        <nav className="mobile-tab-bar">
            <button
                type="button"
                className={`mobile-tab-bar__item ${isActive('/catalog') ? 'mobile-tab-bar__item--active' : ''}`}
                onClick={() => navigate('/catalog')}
            >
                <HomeIcon />
                <span>Каталог</span>
            </button>

            <button type="button" className="mobile-tab-bar__item" onClick={handleFavorites}>
                <HeartIcon />
                <span>Избранное</span>
            </button>

            <button type="button" className="mobile-tab-bar__item mobile-tab-bar__item--create" onClick={onCreateAd}>
                <PlusIcon />
                <span>Создать</span>
            </button>

            <button type="button" className="mobile-tab-bar__item" onClick={handleMessages}>
                <span className="mobile-tab-bar__icon-wrap">
                    <MessageIcon />
                    {msgUnread > 0 && <span className="mobile-tab-bar__badge" />}
                </span>
                <span>Чаты</span>
            </button>

            <button
                type="button"
                className={`mobile-tab-bar__item ${isActive('/profile') ? 'mobile-tab-bar__item--active' : ''}`}
                onClick={handleProfile}
            >
                <ProfileIcon />
                <span>Профиль</span>
            </button>
        </nav>
    );
};

export default MobileTabBar;
